module.exports = {
    english: "English",
    slovak: "Slovak",
    deutsch: "Deutsch",
    log_in_via: "Log in via",
    log_in_using_local_account: "Log in using local account",
    per: "per",
    or: "OR",
    user: "User",
    password: "Password",
    device: "Device",
    status: "Status",
    action: "Action",
    imprint_id: "Imprint ID",
    name: "Name",
    brand: "Brand",
    description: "Description",
    timestamp: "Timestamp",
    uptime: "Uptime",
    firmware_version: "Firmware version",
    appliance_on: "The appliance was switched on",
    appliance_off: "The appliance was switched off",
    identification_success: "Identification success rate",
    duration: "Duration",
    energy_consumption: "Energy consumption",
    minutes: "minutes",
    and: "and",
    seconds: "seconds",
    are_you_sure: "Are you sure?",
    unknown: "Unknown",
    merito_energy: "MeriTo Energy",
    last_change: "Last change",
    energy_relay: "Energy",
    in_seconds: "in seconds",
    test_profile: "Test profile",
    relative_error: "Relative error",
    absolute_error: "Absolute error",
    test_value: "Test value",
    no_device: "No device",
    showing: "Showing",
    of: "of",
    rows: "rows",
    mac_address: "MAC address",
    none: "None",
    static: "Static",
    detected_on: "Detected on",
    status_db_update: "Database update",
    ws_icon_connected: "Connected",
    ws_icon_not_connected: "Connection timeout"
}